<script setup lang="ts">
import { AlertDialogRoot, useForwardPropsEmits } from 'reka-ui'

const props = defineProps<{
    open?: boolean
    defaultOpen?: boolean
}>()

const emits = defineEmits<{
    (e: 'update:open', value: boolean): void
}>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
    <AlertDialogRoot v-bind="forwarded">
        <slot />
    </AlertDialogRoot>
</template>
